
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.079 19.97h-15.8a1.278 1.278 0 01-1.277-1.277V6.28a1.278 1.278 0 011.277-1.277h15.8a1.279 1.279 0 011.277 1.277v2.98l4.533-3.008A.715.715 0 0124 6.844v11.288a.7.7 0 01-.38.628.717.717 0 01-.725-.037l-4.539-3v2.975a1.279 1.279 0 01-1.277 1.272zM1.425 18.545h15.506V6.425H1.425zm16.931-4.537l4.219 2.795V8.167l-4.219 2.794z"}})])
          )
        }
      }
    